import { createPermission } from '@backstage/plugin-permission-common';

export const feedbackReadAllPermission = createPermission({
  name: 'hone.feedback.entries.read-all',
  attributes: {},
});
